import React from 'react'
import propTypes from 'prop-types'
import { Checkbox, FormControlLabel, Typography, makeStyles } from '@material-ui/core'
import { ROLE_KEYS, isAllChecked } from '../wizardReducer'

const ROLE_LABELS = {
	serviceProvider: 'Service provider',
	customer: 'Customer',
	salesRepresentative: 'Sales Representative',
	imbera: 'Imbera users'
}

const useStyles = makeStyles((theme) => ({
	wrapper: {
		marginBottom: theme.spacing(2)
	},
	label: {
		fontSize: '0.75rem',
		marginBottom: theme.spacing(0.5)
	},
	row: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: theme.spacing(0.5)
	},
	error: {
		marginTop: theme.spacing(0.5)
	}
}))

/**
 * Five checkboxes inline. The four role booleans are the source of truth; `All`
 * is derived (`checked={every(individuals)}`) and acts as a master toggle.
 */
const AudienceCheckboxes = ({ audience, error, onToggleRole, onToggleAll }) => {
	const classes = useStyles()
	const everyoneOn = isAllChecked({ audience })

	return (
		<div className={classes.wrapper}>
			<Typography className={classes.label}>Share with</Typography>
			<div className={classes.row}>
				<FormControlLabel
					control={<Checkbox color='primary' checked={everyoneOn} onChange={onToggleAll} />}
					label='All'
				/>
				{ROLE_KEYS.map((k) => (
					<FormControlLabel
						key={k}
						control={<Checkbox color='primary' checked={Boolean(audience[k])} onChange={() => onToggleRole(k)} />}
						label={ROLE_LABELS[k]}
					/>
				))}
			</div>
			{error && (
				<Typography variant='caption' color='error' className={classes.error}>
					{error}
				</Typography>
			)}
		</div>
	)
}

AudienceCheckboxes.propTypes = {
	audience: propTypes.object.isRequired,
	error: propTypes.string,
	onToggleRole: propTypes.func.isRequired,
	onToggleAll: propTypes.func.isRequired
}

AudienceCheckboxes.defaultProps = {
	error: null
}

export default AudienceCheckboxes
